export default __webpack_public_path__ + "static/media/mp_logo_activate_acct.c5e0b970.png";